module.exports = __webpack_public_path__ + "static/media/dada-logo-small.a234dcb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dada-logo-small.svg
// module id = 1248
// module chunks = 1